import { render, staticRenderFns } from "./LessonProgress.vue?vue&type=template&id=0c6c7865&"
import script from "./LessonProgress.vue?vue&type=script&lang=js&"
export * from "./LessonProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Soporte a Proyectos/BBVA/Backups BBVA-Historico/Actualización 2021/TCC-L1 ¿Qué es crédito_/Código fuente/Copia de TCC-L1_org/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VProgressLinear})
